/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OnPaymentMethodAddedRequest
 */
export interface OnPaymentMethodAddedRequest {
    /**
     * 
     * @type {string}
     * @memberof OnPaymentMethodAddedRequest
     */
    companyId: string;
}

/**
 * Check if a given object implements the OnPaymentMethodAddedRequest interface.
 */
export function instanceOfOnPaymentMethodAddedRequest(value: object): value is OnPaymentMethodAddedRequest {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    return true;
}

export function OnPaymentMethodAddedRequestFromJSON(json: any): OnPaymentMethodAddedRequest {
    return OnPaymentMethodAddedRequestFromJSONTyped(json, false);
}

export function OnPaymentMethodAddedRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OnPaymentMethodAddedRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['companyId'],
    };
}

  export function OnPaymentMethodAddedRequestToJSON(json: any): OnPaymentMethodAddedRequest {
      return OnPaymentMethodAddedRequestToJSONTyped(json, false);
  }

  export function OnPaymentMethodAddedRequestToJSONTyped(value?: OnPaymentMethodAddedRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyId': value['companyId'],
    };
}

